import { CustomError } from "ts-custom-error";
export class MastoTimeoutError extends CustomError {
}
